













































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class Topbar extends Vue {
	get headline() {
		return this.$store.getters.headline;
	}

	get hasSubtitle() {
		return this.$store.getters.hasSubtitle;
	}

	get subtitle() {
		return this.$store.getters.subtitle;
	}
}
